<app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="radioButtonValue"
	[label]="step2.getspan4"
	[type]="'radio'"
	[rule]="'required'"
	[errorMessage]="{'required' : 'ctr_1094_HorsDef'}"
	[radios]="[
		{
			label: step2.gettravaux,
			value: travauxValue
		},
		{
			label: step2.getfournitures,
			value: fournituresValue
		},
		{
			label: step2.getservices,
			value: servicesValue
		}
	]"
	[name]="radioButtonCtrlName"
>
</app-form-input>


<app-type-objCPV  [uid]="getUid()" [parentForm]="parentForm" [cpv]="descriptionMarche?.cpv"></app-type-objCPV>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg9" [id]="getStepId() + rg9"></app-form-input-error>
